import { render, staticRenderFns } from "./TestProcessSort.vue?vue&type=template&id=2677de53"
import script from "./TestProcessSort.vue?vue&type=script&lang=js"
export * from "./TestProcessSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports